/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, date: NonNullable<unknown> }} Sub_Addons_Pages_Confirm_Downgrade_Desc_ChangeInputs */



/**
* | output |
* | --- |
* | "Your pages add-on will change to {label} on {date}. You keep your current pages until then." |
*
* @param {Sub_Addons_Pages_Confirm_Downgrade_Desc_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_pages_confirm_downgrade_desc_change = /** @type {((inputs: Sub_Addons_Pages_Confirm_Downgrade_Desc_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Pages_Confirm_Downgrade_Desc_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Seiten-Add-on wechselt am ${i?.date} zu ${i?.label}. Bis dahin behalten Sie Ihre aktuellen Seiten.`)
	return /** @type {LocalizedString} */ (`Your pages add-on will change to ${i?.label} on ${i?.date}. You keep your current pages until then.`)
});